/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import clamp from 'clamp';

interface VisualWorkflowBuilderV2NodeTimeWindowDescriptionWrapperArgs {
  action: ActionModel;
  clampAndShowTooltip: boolean;
}

export default class VisualWorkflowBuilderV2NodeTimeWindowDescriptionWrapper extends Component<VisualWorkflowBuilderV2NodeTimeWindowDescriptionWrapperArgs> {
  @tracked isVisible = false;

  @tracked isClamped = false;
  @tracked clampedContent: string | null = null;

  @tracked infoElement: HTMLDivElement | null = null;

  @action
  didInsert(element: HTMLDivElement) {
    this.infoElement = element;
  }

  @action
  didUpdateStateWhenClamped() {
    this.clampedContent = null;
    this.isClamped = false;
  }

  @action
  didUpdateStateWhenNotClamped() {
    this.clampedContent = null;
    this.isClamped = false;

    if (!this.infoElement || !this.isVisible) {
      return;
    }
    this.performClamp(this.infoElement);
  }

  @action
  onEnterViewport() {
    this.isVisible = true;
    if (this.infoElement) {
      this.performClamp(this.infoElement);
    }
  }

  @action
  performClamp(element: HTMLElement) {
    if (this.args.clampAndShowTooltip) {
      let result = clamp(element, {
        clamp: 2,
        useNativeClamp: false,
      }) as unknown as {
        original: string;
        clamped: string | undefined;
      };

      this.isClamped = !isEmpty(result.clamped);
      if (result.clamped) {
        this.clampedContent = result.clamped;
      }
    }
  }
}
